import { EDiscoverItemLayoutOptions } from '../../../constants/graphqlTypes';
import { LayoutType } from '../types';

/**
 * Map the API's EDiscoverItemLayoutOptions enum to CardV2's LayoutType.
 * Returns 'standard' as the default for null, undefined, or unmapped values.
 */
export function mapLayout(layout?: EDiscoverItemLayoutOptions | null): LayoutType {
  switch (layout) {
    case EDiscoverItemLayoutOptions.FullBleed:
      return 'fullBleed';
    case EDiscoverItemLayoutOptions.Immersive:
      return 'immersive';
    default:
      return 'standard';
  }
}
